import { Button } from '@/components/ui/button';
import { ExternalLink, Monitor } from 'lucide-react';

interface TVDisplayButtonProps {
  workoutId: string;
  size?: 'sm' | 'default';
  variant?: 'outline' | 'ghost' | 'default';
}

export function TVDisplayButton({
  workoutId,
  size = 'sm',
  variant = 'outline',
}: TVDisplayButtonProps) {
  const handleClick = () => {
    window.open(`/tv/${workoutId}`, '_blank');
  };

  return (
    <Button variant={variant} size={size} onClick={handleClick} title="Open TV Display">
      <Monitor className="h-3 w-3 mr-1" />
      TV
      <ExternalLink className="h-2.5 w-2.5 ml-1" />
    </Button>
  );
}
